import React from "react";

const Pending = () => {
  return (
    <div className="container">
      <h2>Pago Pendiente ⏳</h2>
      <p>Tu pago está en proceso. Te notificaremos cuando se complete.</p>
    </div>
  );
};

export default Pending;
